import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/src/view/styles/variables';
import { MatchingAssessmentDiagnosisInfoStepVariant } from '@lean-body/src/domain/matching_assessment_diagnosis_steps';
import { DiagnosisStepFooter } from '../molecules';
const imageSources = {
    noRightAnswer: '/assets/images/goal_matching_assessments/diagnosis_no_right_answer.png',
    lifestyle: '/assets/images/goal_matching_assessments/diagnosis_lifestyle.png',
    shortExercise: '/assets/images/goal_matching_assessments/diagnosis_short_exercise.png',
    selfAcceptance: '/assets/images/goal_matching_assessments/diagnosis_self_acceptance.png',
    keepGoing: '/assets/images/goal_matching_assessments/diagnosis_keep_going.png',
    progressMakesChange: '/assets/images/goal_matching_assessments/diagnosis_progress_makes_change.png',
    habitMatters: '/assets/images/goal_matching_assessments/diagnosis_habit_matters.png',
    supportedEnvironment: '/assets/images/goal_matching_assessments/diagnosis_supported_environment.png',
    readyToStart: '/assets/images/goal_matching_assessments/diagnosis_ready_to_start.png',
    finalCheck: '/assets/images/goal_matching_assessments/diagnosis_final_check.png',
};
export const MatchingAssessmentDiagnosisInfoStep = ({ variant, onNext }) => {
    return (React.createElement("div", { className: css(styles.container) },
        variant === MatchingAssessmentDiagnosisInfoStepVariant.noRightAnswer && (React.createElement("div", { className: css(styles.textGroup, styles.textGroupMargin) },
            React.createElement("div", { className: css(styles.boldText) }, "\u6B63\u89E3\u30FB\u4E0D\u6B63\u89E3\u306F\u3042\u308A\u307E\u305B\u3093\u3002"),
            React.createElement("div", { className: css(styles.text) }, "\u4ECA\u306E\u3042\u306A\u305F\u306B\u5408\u3046\u65B9\u6CD5\u3092\u898B\u3064\u3051\u308B\u305F\u3081\u306E\u8A3A\u65AD\u3067\u3059\uD83D\uDD0D"))),
        variant === MatchingAssessmentDiagnosisInfoStepVariant.lifestyle && (React.createElement("div", { className: css(styles.textGroup) },
            React.createElement("div", { className: css(styles.text) },
                "\u8EAB\u4F53\u3092\u5909\u3048\u308B\u306E\u306F\u3001",
                React.createElement("br", null),
                "\u904B\u52D5\u3060\u3051\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002"),
            React.createElement("div", { className: css(styles.text) },
                "LEAN BODY\u3067\u306F\u3001",
                React.createElement("br", null),
                React.createElement("div", { className: css(styles.boldText) },
                    React.createElement("span", { className: css(styles.emphasis) },
                        "\u904B\u52D5\u30FB\u98DF\u4E8B\u30FB\u751F\u6D3B\u7FD2\u6163\u304B\u3089\u3001",
                        React.createElement("br", null),
                        "\u3042\u306A\u305F\u306B\u5408\u3046\u5F62"),
                    "\u3092\u898B\u3064\u3051\u307E\u3059\uD83D\uDE0A")),
            React.createElement("div", { className: css(styles.text) }, "\u3042\u306A\u305F\u306E\u30DA\u30FC\u30B9\u3067\u7D9A\u3051\u3089\u308C\u307E\u3059\uD83C\uDF3F"))),
        variant === MatchingAssessmentDiagnosisInfoStepVariant.shortExercise && (React.createElement("div", { className: css(styles.textGroup) },
            React.createElement("div", { className: css(styles.text) }, "\u904B\u52D5\u306F\u3001\u9577\u6642\u9593\u884C\u3046\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093 \u23F1\uFE0F"),
            React.createElement("div", { className: css(styles.text) }, "\u7814\u7A76\u3067\u3082\u3001\u77ED\u6642\u9593\u306E\u904B\u52D5\u3092\u7FD2\u6163\u3068\u3057\u3066\u7D9A\u3051\u308B\u3053\u3068\u304C\u3001\u76EE\u6A19\u9054\u6210\u306B\u3064\u306A\u304C\u308A\u3084\u3059\u3044\u3068\u5206\u304B\u3063\u3066\u3044\u307E\u3059\uD83D\uDCCA"),
            React.createElement("div", { className: css(styles.boldText) }, "\u305F\u3063\u305F5\u5206\u3001\u4F53\u3092\u52D5\u304B\u3059\u3053\u3068\u3082\u5927\u5207\u306A\u4E00\u6B69\u3067\u3059\uD83C\uDFC3\u2728"))),
        variant === MatchingAssessmentDiagnosisInfoStepVariant.selfAcceptance && (React.createElement("div", { className: css(styles.textGroup, styles.textGroupMargin) },
            React.createElement("div", { className: css(styles.text) }, "\u3053\u3053\u307E\u3067\u306E\u7B54\u3048\u3092\u898B\u308B\u3068\u3001\u98DF\u4E8B\u3084\u6C17\u5206\u304C\u4E71\u308C\u3066\u3057\u307E\u3046\u306E\u306B\u306F\u3001\u7406\u7531\u304C\u3042\u308B\u3053\u3068\u304C\u5206\u304B\u308A\u307E\u3059\uD83D\uDCA1"),
            React.createElement("div", { className: css(styles.text) },
                "\u307E\u305A\u306F\u3001",
                React.createElement("span", { className: css(styles.boldText) }, "\u4ECA\u306E\u81EA\u5206\u3092\u5426\u5B9A\u3057\u306A\u3044"),
                "\u3053\u3068\u304B\u3089\u59CB\u3081\u3066\u3044\u304D\u307E\u3057\u3087\u3046\uD83C\uDF3F"))),
        variant === MatchingAssessmentDiagnosisInfoStepVariant.keepGoing && (React.createElement("div", { className: css(styles.textGroup) },
            React.createElement("div", { className: css(styles.text) },
                "\u3053\u308C\u307E\u3067\u7D9A\u304B\u306A\u304B\u3063\u305F\u306E\u306F\u3001",
                React.createElement("span", { className: css(styles.boldText) }, "\u3042\u306A\u305F\u306E\u610F\u5FD7\u304C\u5F31\u304B\u3063\u305F\u304B\u3089\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002")),
            React.createElement("div", { className: css(styles.text) }, "\u591A\u304F\u306E\u5834\u5408\u300C\u6700\u521D\u304B\u3089\u9811\u5F35\u308A\u3059\u304E\u308B\u8A2D\u8A08\u300D\u304C\u751F\u6D3B\u306B\u5408\u3063\u3066\u3044\u306A\u304B\u3063\u305F\u3060\u3051\u306A\u306E\u3067\u3059\uD83E\uDDE0"),
            React.createElement("div", { className: css(styles.text) }, "\u7121\u7406\u306A\u304F\u7D9A\u304F\u5F62\u3092\u9078\u3076\u3053\u3068\u304C\u3001\u7D50\u679C\u7684\u306B\u4F53\u3092\u5909\u3048\u3066\u3044\u304D\u307E\u3059\uD83C\uDF31\u2728"))),
        variant === MatchingAssessmentDiagnosisInfoStepVariant.progressMakesChange && (React.createElement("div", { className: css(styles.textGroup) },
            React.createElement("div", { className: css(styles.text) }, "\u5B8C\u74A7\u306B\u59CB\u3081\u308B\u5FC5\u8981\u306F\u3042\u308A\u307E\u305B\u3093\u3002"),
            React.createElement("div", { className: css(styles.text) },
                "\u5927\u5207\u306A\u306E\u306F\u3001\u3067\u304D\u308B\u65E5\u304B\u3089\u3001",
                React.createElement("br", null),
                "\u3067\u304D\u308B\u3053\u3068\u3092\u3084\u308B\u3053\u3068\u3002"),
            React.createElement("div", { className: css(styles.boldText) },
                "\u3067\u304D\u305F\u65E5\u3092\u8A8D\u3081\u308B\u3053\u3068\u3002",
                React.createElement("br", null),
                "\u305D\u306E\u7A4D\u307F\u91CD\u306D\u3067\u3001\u4EBA\u306F\u5C11\u3057\u305A\u3064\u3001\u78BA\u5B9F\u306B\u5909\u308F\u308A\u307E\u3059\u2728\uD83D\uDCC8"))),
        variant === MatchingAssessmentDiagnosisInfoStepVariant.habitMatters && (React.createElement("div", { className: css(styles.textGroup) },
            React.createElement("div", { className: css(styles.text) },
                "\u4F53\u91CD\u3084\u898B\u305F\u76EE\u306E\u5909\u5316\u306F\u3001",
                React.createElement("br", null),
                "\u5206\u304B\u308A\u3084\u3059\u3044\u6210\u679C\u306E\u3072\u3068\u3064\u3067\u3059 \uD83D\uDC57"),
            React.createElement("div", { className: css(styles.text) },
                "\u3067\u3082\u672C\u5F53\u306B\u5927\u5207\u306A\u306E\u306F\u3001",
                React.createElement("br", null),
                "\u305D\u306E\u72B6\u614B\u3092\u7121\u7406\u306A\u304F\u4FDD\u3066\u308B\u3053\u3068\u3002"),
            React.createElement("div", { className: css(styles.boldText) },
                "\u7D9A\u3051\u3089\u308C\u308B\u904B\u52D5\u7FD2\u6163\u306F\u3001",
                React.createElement("br", null),
                "\u4ECA\u3060\u3051\u3067\u306A\u304F\u3001\u3053\u308C\u304B\u3089\u306E\u5065\u5EB7\u306B\u3082\u3064\u306A\u304C\u3063\u3066\u3044\u304D\u307E\u3059\uD83D\uDD4A\uFE0F"),
            React.createElement("div", { className: css(styles.text) },
                "\u3044\u307E\u9078\u3076\u884C\u52D5\u306F\u3001",
                React.createElement("br", null),
                "\u672A\u6765\u306E\u81EA\u5206\u3078\u306E\u6295\u8CC7\u3067\u3082\u3042\u308A\u307E\u3059\uD83C\uDF38\u2728"))),
        variant === MatchingAssessmentDiagnosisInfoStepVariant.supportedEnvironment && (React.createElement("div", { className: css(styles.textGroup) },
            React.createElement("div", { className: css(styles.text) }, "\u3082\u3046\u4E00\u4EBA\u3067\u60A9\u307E\u306A\u3044\u3067\uD83D\uDE0A"),
            React.createElement("div", { className: css(styles.boldText) },
                "\u7D9A\u3051\u308B\u305F\u3081\u306B\u5FC5\u8981\u306A\u306E\u306F\u3001",
                React.createElement("br", null),
                "\u3082\u3063\u3068\u9811\u5F35\u308B\u3053\u3068\u3067\u306F\u306A\u304F\u3001",
                React.createElement("br", null),
                "\u652F\u3048\u3066\u304F\u308C\u308B\u74B0\u5883\u3067\u3059 \uD83E\uDD1D"),
            React.createElement("div", { className: css(styles.text) }, "LEAN BODY\u3067\u306F\u3001\u30D7\u30ED\u306E\u30A4\u30F3\u30B9\u30C8\u30E9\u30AF\u30BF\u30FC\u3084LIVE\u914D\u4FE1\u3092\u901A\u3057\u3066\u3001\u4E00\u7DD2\u306B\u9032\u3081\u308B\u5834\u6240\u3092\u7528\u610F\u3057\u3066\u3044\u307E\u3059 \uD83C\uDFA5\uD83D\uDCAC"))),
        variant === MatchingAssessmentDiagnosisInfoStepVariant.readyToStart && (React.createElement("div", { className: css(styles.textGroup) },
            React.createElement("div", { className: css(styles.text) },
                "\u3053\u3053\u307E\u3067\u3001\u81EA\u5206\u306E\u8EAB\u4F53\u3084\u7FD2\u6163\u3068",
                React.createElement("br", null),
                "\u3057\u3063\u304B\u308A\u5411\u304D\u5408\u3063\u3066\u304D\u307E\u3057\u305F \uD83C\uDF31"),
            React.createElement("div", { className: css(styles.text) },
                "\u305D\u308C\u3060\u3051\u3067\u3001",
                React.createElement("span", { className: css(styles.boldText) },
                    "\u59CB\u3081\u308B\u6E96\u5099\u306F\u3001",
                    React.createElement("br", null),
                    "\u3082\u3046\u6574\u3063\u3066\u3044\u307E\u3059"),
                ' ',
                "\uD83D\uDE0A\u2728"),
            React.createElement("div", { className: css(styles.text) }, "\u3042\u3068\u306F\u3001\u3042\u306A\u305F\u306E\u751F\u6D3B\u306B\u5408\u308F\u305B\u308B\u3060\u3051 \uD83E\uDDE9"))),
        variant === MatchingAssessmentDiagnosisInfoStepVariant.finalCheck && (React.createElement("div", { className: css(styles.textGroup, styles.textGroupMarginB) },
            React.createElement("div", { className: css(styles.text) },
                "\u3042\u306A\u305F\u5C02\u7528\u30D7\u30E9\u30F3\u3092\u5B8C\u6210\u3055\u305B\u308B\u305F\u3081\u3001",
                React.createElement("br", null),
                "\u6700\u5F8C\u306B\u3044\u304F\u3064\u304B\u78BA\u8A8D\u3055\u305B\u3066\u304F\u3060\u3055\u3044 \uD83D\uDCDD\u2728"))),
        React.createElement("img", { className: css(styles.photo), src: imageSources[variant], alt: "" }),
        React.createElement(DiagnosisStepFooter, { isDisabled: false, onNext: onNext, buttonText: "\u6B21\u3078" })));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
        textAlign: 'center',
        [MediaBreakPointUp.MD]: {
            maxWidth: 327,
            margin: '0 auto',
        },
    },
    textGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
    },
    textGroupMargin: {
        marginTop: 40,
    },
    textGroupMarginB: {
        marginTop: 100,
    },
    text: {
        color: Colors.TextDark,
        fontSize: 16,
        lineHeight: '160%',
        letterSpacing: 1.28,
    },
    textSpacing: {},
    emphasis: {
        color: Colors.Accent,
    },
    boldText: {
        color: Colors.TextDark,
        fontSize: 20,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 1.6,
    },
    photo: {
        width: '100%',
        borderRadius: 8,
        objectFit: 'cover',
    },
});
